import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  orderCancelAndRefund,
  orderEligibilitiesMockEligibleFororderForMultiPaxOneWay,
  orderForMultiPaxOneWay,
  orderForMultiPaxOneWayWithFixedDate,
  orderForUnOnlyRoundTripTemplateWithoutContactEmail,
} from '../../../mock/data/index';
import {
  flightDisruptionWarning,
} from '../../../mock/dictionaries';

/**
 * Mocks for refundable order for subset of passengers.
 */
export const eligibleForRefundSubsetOfPassengersMock: MockMap = {
  retrieveOrder: [createMockData(orderForMultiPaxOneWay, [], [flightDisruptionWarning])],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockEligibleFororderForMultiPaxOneWay)],
  cancelAndRefundOrder: [createMockData(orderCancelAndRefund)]
};

/**
 * Mocks for refundable order for subset of passengers.
 */
export const eligibleForRefundSubsetOfPassengersWithFixedDateMock: MockMap = {
  retrieveOrder: [createMockData(orderForMultiPaxOneWayWithFixedDate, [], [flightDisruptionWarning])],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockEligibleFororderForMultiPaxOneWay)],
  cancelAndRefundOrder: [createMockData(orderCancelAndRefund)]
};

/**
 * Mocks for refundable order for subset of passengers without contact email.
 */
export const eligibleForRefundSubsetOfPassengersWithoutContactEmailMock: MockMap = {
  retrieveOrder: [createMockData(orderForUnOnlyRoundTripTemplateWithoutContactEmail, [], [flightDisruptionWarning])],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockEligibleFororderForMultiPaxOneWay)],
  cancelAndRefundOrder: [createMockData(orderCancelAndRefund)]
};
